module.exports = __webpack_public_path__ + "static/media/buddy-letter-envelope.ec1010b0.svg";